{
  "102": {
    "pref": "東京都",
    "city": "千代田区"
  },
  "174": {
    "pref": "東京都",
    "city": "板橋区"
  },
  "185": {
    "pref": "東京都",
    "city": "国分寺市"
  },
  "213": {
    "pref": "神奈川県",
    "city": "川崎市高津区"
  },
  "226": {
    "pref": "神奈川県",
    "city": "横浜市緑区"
  },
  "230": {
    "pref": "神奈川県",
    "city": "横浜市鶴見区"
  },
  "254": {
    "pref": "神奈川県",
    "city": "平塚市"
  },
  "273": {
    "pref": "千葉県",
    "city": "船橋市"
  },
  "277": {
    "pref": "千葉県",
    "city": "柏市"
  },
  "279": {
    "pref": "千葉県",
    "city": "浦安市"
  },
  "310": {
    "pref": "茨城県",
    "city": "水戸市"
  },
  "321": {
    "pref": "栃木県",
    "city": "宇都宮市"
  },
  "340": {
    "pref": "埼玉県",
    "city": "草加市"
  },
  "342": {
    "pref": "埼玉県",
    "city": "吉川市"
  },
  "343": {
    "pref": "埼玉県",
    "city": "越谷市"
  },
  "384": {
    "pref": "群馬県",
    "city": "吾妻郡嬬恋村"
  },
  "389": {
    "pref": "群馬県",
    "city": "安中市"
  },
  "463": {
    "pref": "愛知県",
    "city": "名古屋市守山区"
  },
  "464": {
    "pref": "愛知県",
    "city": "名古屋市千種区"
  },
  "467": {
    "pref": "愛知県",
    "city": "名古屋市瑞穂区"
  },
  "470": {
    "pref": "愛知県",
    "city": "豊田市"
  },
  "480": {
    "pref": "愛知県",
    "city": "瀬戸市"
  },
  "486": {
    "pref": "愛知県",
    "city": "春日井市"
  },
  "491": {
    "pref": "愛知県",
    "city": "一宮市"
  },
  "501": {
    "pref": "岐阜県",
    "city": "岐阜市"
  },
  "503": {
    "pref": "岐阜県",
    "city": "大垣市"
  },
  "510": {
    "pref": "三重県",
    "city": "津市"
  },
  "514": {
    "pref": "三重県",
    "city": "津市"
  },
  "517": {
    "pref": "三重県",
    "city": "伊勢市"
  },
  "518": {
    "pref": "三重県",
    "city": "名張市"
  },
  "520": {
    "pref": "滋賀県",
    "city": "大津市"
  },
  "525": {
    "pref": "滋賀県",
    "city": "草津市"
  },
  "530": {
    "pref": "大阪府",
    "city": "大阪市北区"
  },
  "531": {
    "pref": "大阪府",
    "city": "大阪市北区"
  },
  "532": {
    "pref": "大阪府",
    "city": "大阪市淀川区"
  },
  "533": {
    "pref": "大阪府",
    "city": "大阪市東淀川区"
  },
  "534": {
    "pref": "大阪府",
    "city": "大阪市都島区"
  },
  "535": {
    "pref": "大阪府",
    "city": "大阪市旭区"
  },
  "536": {
    "pref": "大阪府",
    "city": "大阪市城東区"
  },
  "537": {
    "pref": "大阪府",
    "city": "大阪市東成区"
  },
  "538": {
    "pref": "大阪府",
    "city": "大阪市鶴見区"
  },
  "540": {
    "pref": "大阪府",
    "city": "大阪市中央区"
  },
  "541": {
    "pref": "大阪府",
    "city": "大阪市中央区"
  },
  "542": {
    "pref": "大阪府",
    "city": "大阪市中央区"
  },
  "543": {
    "pref": "大阪府",
    "city": "大阪市天王寺区"
  },
  "544": {
    "pref": "大阪府",
    "city": "大阪市生野区"
  },
  "545": {
    "pref": "大阪府",
    "city": "大阪市阿倍野区"
  },
  "546": {
    "pref": "大阪府",
    "city": "大阪市東住吉区"
  },
  "547": {
    "pref": "大阪府",
    "city": "大阪市平野区"
  },
  "550": {
    "pref": "大阪府",
    "city": "大阪市西区"
  },
  "551": {
    "pref": "大阪府",
    "city": "大阪市大正区"
  },
  "552": {
    "pref": "大阪府",
    "city": "大阪市港区"
  },
  "553": {
    "pref": "大阪府",
    "city": "大阪市福島区"
  },
  "554": {
    "pref": "大阪府",
    "city": "大阪市此花区"
  },
  "555": {
    "pref": "大阪府",
    "city": "大阪市西淀川区"
  },
  "556": {
    "pref": "大阪府",
    "city": "大阪市浪速区"
  },
  "557": {
    "pref": "大阪府",
    "city": "大阪市西成区"
  },
  "558": {
    "pref": "大阪府",
    "city": "大阪市住吉区"
  },
  "559": {
    "pref": "大阪府",
    "city": "大阪市住之江区"
  },
  "560": {
    "pref": "大阪府",
    "city": "豊中市"
  },
  "561": {
    "pref": "大阪府",
    "city": "豊中市"
  },
  "562": {
    "pref": "大阪府",
    "city": "箕面市"
  },
  "563": {
    "pref": "大阪府",
    "city": "池田市"
  },
  "564": {
    "pref": "大阪府",
    "city": "吹田市"
  },
  "565": {
    "pref": "大阪府",
    "city": "吹田市"
  },
  "566": {
    "pref": "大阪府",
    "city": "摂津市"
  },
  "567": {
    "pref": "大阪府",
    "city": "茨木市"
  },
  "569": {
    "pref": "大阪府",
    "city": "高槻市"
  },
  "570": {
    "pref": "大阪府",
    "city": "守口市"
  },
  "571": {
    "pref": "大阪府",
    "city": "門真市"
  },
  "572": {
    "pref": "大阪府",
    "city": "寝屋川市"
  },
  "573": {
    "pref": "大阪府",
    "city": "枚方市"
  },
  "574": {
    "pref": "大阪府",
    "city": "大東市"
  },
  "575": {
    "pref": "大阪府",
    "city": "四條畷市"
  },
  "576": {
    "pref": "大阪府",
    "city": "交野市"
  },
  "577": {
    "pref": "大阪府",
    "city": "東大阪市"
  },
  "578": {
    "pref": "大阪府",
    "city": "東大阪市"
  },
  "579": {
    "pref": "大阪府",
    "city": "東大阪市"
  },
  "580": {
    "pref": "大阪府",
    "city": "松原市"
  },
  "581": {
    "pref": "大阪府",
    "city": "八尾市"
  },
  "582": {
    "pref": "大阪府",
    "city": "柏原市"
  },
  "583": {
    "pref": "大阪府",
    "city": "羽曳野市"
  },
  "584": {
    "pref": "大阪府",
    "city": "富田林市"
  },
  "586": {
    "pref": "大阪府",
    "city": "河内長野市"
  },
  "587": {
    "pref": "大阪府",
    "city": "堺市美原区"
  },
  "589": {
    "pref": "大阪府",
    "city": "大阪狭山市"
  },
  "590": {
    "pref": "大阪府",
    "city": "堺市堺区"
  },
  "591": {
    "pref": "大阪府",
    "city": "堺市北区"
  },
  "592": {
    "pref": "大阪府",
    "city": "堺市西区"
  },
  "593": {
    "pref": "大阪府",
    "city": "堺市西区"
  },
  "594": {
    "pref": "大阪府",
    "city": "和泉市"
  },
  "595": {
    "pref": "大阪府",
    "city": "泉大津市"
  },
  "596": {
    "pref": "大阪府",
    "city": "岸和田市"
  },
  "597": {
    "pref": "大阪府",
    "city": "貝塚市"
  },
  "598": {
    "pref": "大阪府",
    "city": "泉佐野市"
  },
  "599": {
    "pref": "大阪府",
    "city": "堺市中区"
  },
  "600": {
    "pref": "京都府",
    "city": "京都市下京区"
  },
  "601": {
    "pref": "京都府",
    "city": "京都市北区"
  },
  "602": {
    "pref": "京都府",
    "city": "京都市上京区"
  },
  "603": {
    "pref": "京都府",
    "city": "京都市北区"
  },
  "604": {
    "pref": "京都府",
    "city": "京都市中京区"
  },
  "607": {
    "pref": "京都府",
    "city": "京都市山科区"
  },
  "610": {
    "pref": "京都府",
    "city": "京都市西京区"
  },
  "611": {
    "pref": "京都府",
    "city": "宇治市"
  },
  "612": {
    "pref": "京都府",
    "city": "京都市伏見区"
  },
  "613": {
    "pref": "京都府",
    "city": "京都市伏見区"
  },
  "614": {
    "pref": "京都府",
    "city": "八幡市"
  },
  "615": {
    "pref": "京都府",
    "city": "京都市右京区"
  },
  "617": {
    "pref": "京都府",
    "city": "向日市"
  },
  "619": {
    "pref": "京都府",
    "city": "木津川市"
  },
  "620": {
    "pref": "京都府",
    "city": "福知山市"
  },
  "621": {
    "pref": "京都府",
    "city": "亀岡市"
  },
  "629": {
    "pref": "京都府",
    "city": "福知山市"
  },
  "630": {
    "pref": "大阪府",
    "city": "東大阪市"
  },
  "631": {
    "pref": "奈良県",
    "city": "奈良市"
  },
  "634": {
    "pref": "奈良県",
    "city": "橿原市"
  },
  "635": {
    "pref": "奈良県",
    "city": "大和高田市"
  },
  "636": {
    "pref": "奈良県",
    "city": "生駒郡平群町"
  },
  "637": {
    "pref": "奈良県",
    "city": "五條市"
  },
  "639": {
    "pref": "奈良県",
    "city": "大和郡山市"
  },
  "640": {
    "pref": "和歌山県",
    "city": "和歌山市"
  },
  "643": {
    "pref": "和歌山県",
    "city": "伊都郡かつらぎ町"
  },
  "648": {
    "pref": "奈良県",
    "city": "吉野郡野迫川村"
  },
  "649": {
    "pref": "和歌山県",
    "city": "和歌山市"
  },
  "650": {
    "pref": "兵庫県",
    "city": "神戸市中央区"
  },
  "651": {
    "pref": "兵庫県",
    "city": "神戸市北区"
  },
  "652": {
    "pref": "兵庫県",
    "city": "神戸市兵庫区"
  },
  "653": {
    "pref": "兵庫県",
    "city": "神戸市長田区"
  },
  "654": {
    "pref": "兵庫県",
    "city": "神戸市須磨区"
  },
  "655": {
    "pref": "兵庫県",
    "city": "神戸市垂水区"
  },
  "656": {
    "pref": "兵庫県",
    "city": "洲本市"
  },
  "657": {
    "pref": "兵庫県",
    "city": "神戸市東灘区"
  },
  "658": {
    "pref": "兵庫県",
    "city": "神戸市東灘区"
  },
  "659": {
    "pref": "兵庫県",
    "city": "芦屋市"
  },
  "660": {
    "pref": "兵庫県",
    "city": "尼崎市"
  },
  "661": {
    "pref": "兵庫県",
    "city": "尼崎市"
  },
  "662": {
    "pref": "兵庫県",
    "city": "西宮市"
  },
  "663": {
    "pref": "兵庫県",
    "city": "西宮市"
  },
  "664": {
    "pref": "兵庫県",
    "city": "伊丹市"
  },
  "665": {
    "pref": "兵庫県",
    "city": "宝塚市"
  },
  "666": {
    "pref": "兵庫県",
    "city": "宝塚市"
  },
  "669": {
    "pref": "兵庫県",
    "city": "神戸市北区"
  },
  "670": {
    "pref": "兵庫県",
    "city": "姫路市"
  },
  "671": {
    "pref": "兵庫県",
    "city": "姫路市"
  },
  "673": {
    "pref": "兵庫県",
    "city": "明石市"
  },
  "675": {
    "pref": "兵庫県",
    "city": "加古川市"
  },
  "677": {
    "pref": "兵庫県",
    "city": "西脇市"
  },
  "680": {
    "pref": "鳥取県",
    "city": "鳥取市"
  },
  "698": {
    "pref": "島根県",
    "city": "益田市"
  },
  "700": {
    "pref": "岡山県",
    "city": "岡山市北区"
  },
  "702": {
    "pref": "岡山県",
    "city": "岡山市中区"
  },
  "710": {
    "pref": "岡山県",
    "city": "岡山市南区"
  },
  "711": {
    "pref": "岡山県",
    "city": "倉敷市"
  },
  "730": {
    "pref": "広島県",
    "city": "広島市中区"
  },
  "739": {
    "pref": "広島県",
    "city": "広島市安佐北区"
  },
  "769": {
    "pref": "香川県",
    "city": "高松市"
  },
  "770": {
    "pref": "徳島県",
    "city": "徳島市"
  },
  "771": {
    "pref": "徳島県",
    "city": "徳島市"
  },
  "781": {
    "pref": "高知県",
    "city": "高知市"
  },
  "792": {
    "pref": "愛媛県",
    "city": "今治市"
  },
  "802": {
    "pref": "福岡県",
    "city": "北九州市小倉北区"
  },
  "807": {
    "pref": "福岡県",
    "city": "北九州市八幡西区"
  },
  "811": {
    "pref": "福岡県",
    "city": "福岡市東区"
  },
  "813": {
    "pref": "福岡県",
    "city": "福岡市東区"
  },
  "814": {
    "pref": "福岡県",
    "city": "福岡市城南区"
  },
  "838": {
    "pref": "福岡県",
    "city": "小郡市"
  },
  "852": {
    "pref": "長崎県",
    "city": "長崎市"
  },
  "861": {
    "pref": "熊本県",
    "city": "熊本市中央区"
  },
  "885": {
    "pref": "宮崎県",
    "city": "都城市"
  },
  "899": {
    "pref": "鹿児島県",
    "city": "鹿児島市"
  },
  "904": {
    "pref": "沖縄県",
    "city": "沖縄市"
  },
  "911": {
    "pref": "福井県",
    "city": "勝山市"
  },
  "924": {
    "pref": "石川県",
    "city": "白山市"
  }
}